import { Component, Inject, Input, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from 'ui-library';

@Component({
  selector: 'app-welcome',
  imports: [TranslateModule, ButtonComponent],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent {
  @Input() language: string = "fr-FR";

  constructor(
    @Optional() public dialogRef: MatDialogRef<WelcomeComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,) {
    if (data) {
      this.language = this.data.language;
    }
  }

  confirm(): void {
    this.dialogRef.close({ action: 'confirm' });
  }
}
